import { render } from "./List.vue?vue&type=template&id=20fbfe71&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=20fbfe71&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fbfe71"]])

export default __exports__